import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import TR from '../../Trans';
import { Capacitor } from '@capacitor/core';
import ExternalViewCommands from '../../services/external';
import sessionStore from '../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import settingsStore from '../../stores/settings';
import newTracksStore from '../../stores/newTracks';
import musicPlayerStore from '../../stores/musicPlayer';
import playerStore from '../../stores/player';

function Messenger() {

  const isSongbookPublicMode = sessionStore((state) => state.isSongbookPublicMode);
  const isSongbookLoggedIn = sessionStore((state) => state.isSongbookLoggedIn);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const account = accountStore((state) => state.account);
  const playQueue = performanceStore((state) => state.playQueue);
  const settings = settingsStore((state) => state.settings);
  const isStopped = playerStore((state) => state.isStopped);
  const newTracks = newTracksStore((state) => state.tracks);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const countdown = performanceStore((state) => state.countdown);
  const setCurrentTitle = performanceStore((state) => state.setCurrentTitle);
  const setPlayQueueTrackList = performanceStore((state) => state.setPlayQueueTrackList);
  const setNextSingerTitle = performanceStore((state) => state.setNextSingerTitle);
  const setNewTracksTitle = newTracksStore((state) => state.setNewTracksTitle);

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / (3600));
    var minutes = Math.floor(sec_num / 60) % 60;
    if (hours > 0) {
      return hours + "h " + minutes;
    } else {
      return minutes;
    }
  };

  const initIosSubscriptions = () => {
    performanceStore.subscribe((state) => state.countdown, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"countdown\": " + val + "}')");
    });
    performanceStore.subscribe((state) => state.currentPerformance, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentPerformance\": " + JSON.stringify(val) + "}')");
    });
    performanceStore.subscribe((state) => state.nextPerformance, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextPerformance\": " + JSON.stringify(val) + "}')");
    });
    performanceStore.subscribe((state) => state.playQueue, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueue\": " + JSON.stringify(val) + "}')");
    });
    //newTracksStore.subscribe((state) => state.tracks, (val, prev) => {ExternalViewCommands.invokeJSOnExternalView("window.setNewTracksStore('{\"tracks\": " + JSON.stringify(val) + "}')"); });
    playerStore.subscribe((state) => state.isPlaying, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"isPlaying\": {\"isPlaying\": " + val.isPlaying + "}}')");
    });
    playerStore.subscribe((state) => state.isStopped, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"isStopped\": {\"isStopped\": " + val.isStopped + "}}')");
    });
    playerStore.subscribe((state) => state.streamUrl, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"streamUrl\": \"" + val + "\", \"currentTime\":" + playerStore.getState().currentTime + "}')");
    });
    playerStore.subscribe((state) => state.from, (val, prev) => {
      if (!(Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios' && !playerStore.getState().hasBeenPlayed)) {
        ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"from\": {\"from\": " + val.from + "}}')");
      }
    });
    playerStore.subscribe((state) => state.iosFrom, (val, prev) => {
      if (val?.from) {
        ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"iosFrom\": {\"from\": " + val.from + "}}')");
      }
    });
    accountStore.subscribe((state) => state.account, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setAccountStore('{\"account\": " + JSON.stringify(val) + "}')");
    });
    settingsStore.subscribe((state) => state.settings, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setSettingsStore('{\"settings\": " + JSON.stringify(val) + "}')");
    });
    accountStore.subscribe((state) => state.urls, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setAccountStore('{\"urls\": " + JSON.stringify(val) + "}')");
    });
    //performanceStore.subscribe((state) => state.playQueueTrackList, (val, prev) => {ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"" + val + "\"}')"); });
    performanceStore.subscribe((state) => state.currentTitle, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentTitle\": \"" + val + "\"}')");
    });
    //performanceStore.subscribe((state) => state.nextSingerTitle, (val, prev) => {ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"" + val + "\"}')"); });
    playerStore.subscribe((state) => state.currentVolume, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"currentVolume\": {\"currentVolume\":" + val.currentVolume + "}}')");
    });
    musicPlayerStore.subscribe((state) => state.isMusicOn, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setMusicPlayerStore('{\"isMusicOn\": " + val + "}')");
    });
    musicPlayerStore.subscribe((state) => state.isMusicReallyPaused, (val, prev) => {
      ExternalViewCommands.invokeJSOnExternalView("window.setMusicPlayerStore('{\"isMusicReallyPaused\": {\"isPaused\": " + val.isPaused + "}}')");
    });
  };

  const playQueueListStr = () => {
    if (settings) {
      let autoPlaySecs = settings.autoplay_enabled ? settings.autoplay_secs : 0;
      let list = TR.cm_after_this + ": ";
      if (playQueue) {
        let currentTimeDef = playerStore.getState().currentTime ? playerStore.getState().currentTime : 0;
        for (let i = 1; i < Math.min(settings.num_singers_shown + 1, playQueue.items.length); i++) {
          if (!nextPerformance) {
            list += playQueue.items[i].profile.name + " (" + toMinutes((playQueue.items[i].incoming + i * autoPlaySecs - currentTimeDef)) + " min)";
          } else {
            list += playQueue.items[i].profile.name + " (" + toMinutes((playQueue.items[i].incoming + i * autoPlaySecs + countdown - currentTimeDef)) + " min)";
          }
          if (i < Math.min(settings.num_singers_shown + 1, playQueue.items.length) - 1) {
            list += ", ";
          }
        }
        if (Math.min(settings.num_singers_shown + 1, playQueue.items.length) > 1) {
          return list;
        } else {
          return "";
        }
      }
    }
  };

  const createNewTracksTitleStr = () => {
    let newTracksTitle = "";
    if (newTracks) {
      let newTracksSlice = newTracks.slice(0, 20);
      let length = newTracksSlice.length;
      for (let i = 0; i < length; i++) {
        let item = newTracksSlice[i];
        newTracksTitle += item.artist + " - " + item.title + "#";
      }
    }
    newTracksTitle = newTracksTitle.replace(/"/g, '');
    return newTracksTitle;
  };

  const emitPlayQueueListStr = () => {
    if (playQueue) {
      let str = playQueueListStr();
      setPlayQueueTrackList(str);
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"" + str + "\"}')");
    } else {
      setPlayQueueTrackList("");
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"\"}')");
    }
  };

  const emitNextSingerTitle = () => {
    if (playQueue) {
      let nextSinger = playQueue.items.length > 1 ? TR.cm_next + ": " + playQueue.items[1].profile.name : "";
      setNextSingerTitle(nextSinger);
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"" + nextSinger + "\"}')");
    } else {
      setNextSingerTitle("");
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"\"}')");
    }
  };

  const emitCurrentTitle = () => {
    if (currentPerformance) {
      if (isStopped.isStopped) {
        let title = TR.cm_performer_now + ": " + currentPerformance.profile.name;
        setCurrentTitle(title);
        ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentTitle\": \"" + title + "\"}')");
      } else {
        let title = TR.cm_performer_now + ": " + currentPerformance.profile.name + " - " + currentPerformance.track.title;
        setCurrentTitle(title);
        ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentTitle\": \"" + title + "\"}')");
      }
    } else {
      setCurrentTitle("");
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentTitle\": \"\"}')");
    }
  };

  const emitNewTracks = () => {
    if (newTracks) {
      let title = createNewTracksTitleStr();
      console.log("new tracks", title);
      ExternalViewCommands.invokeJSOnExternalView("window.setNewTracksTitle(\"" + title + "\")");
      setNewTracksTitle(title);
    }
  };

  useEffect(() => {
    emitPlayQueueListStr();
    emitNextSingerTitle();
  }, [playQueue]);

  useEffect(() => {
    if (nextPerformance && countdown > 0) {
      emitPlayQueueListStr();
      emitNextSingerTitle();
    }
  }, [countdown]);

  useEffect(() => {
    if (playerStore.getState().currentTime) {
      emitPlayQueueListStr();
      emitNextSingerTitle();
    }
  }, [playerStore.getState().currentTime]);

  useEffect(() => {
    emitCurrentTitle();
  }, [currentPerformance]);

  useEffect(() => {
    emitCurrentTitle();
  }, [isStopped]);

  useEffect(() => {
    emitNewTracks();
  }, [newTracks]);

  useEffect(() => {
    if (isLoggedIn && !isSongbookLoggedIn && !isSongbookPublicMode) {
      initIosSubscriptions();
    }
  }, []);

  useEffect(() => {
    if (settings) {
      let str = playQueueListStr();
      setPlayQueueTrackList(str);
    }
  }, [settings]);

  useEffect(() => {
    emitPlayQueueListStr();
    emitNextSingerTitle();
    emitCurrentTitle();
    emitNewTracks();
  }, [account]);

  return (
    <div>
    </div>
  );
}

export default Messenger;
